var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('v-card-title',{staticClass:"px-0 pt-0"},[_vm._v("Description")]),_c('editor',{attrs:{"id":"tinymce-editor","api-key":"qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc","init":{
      height: 500,
      menubar: false,
      plugins: [
        'advlist anchor autolink autosave code codesample directionality fullscreen hr image imagetools insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textpattern visualblocks visualchars wordcount',
      ],
      toolbar: [
        'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code codesample',
        'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
      ],
    }},on:{"input":_vm.updateContent},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }